<template>
  <div class="bb-px2pt6 border-box">
    <div class="clearfix relative">
      <div class="xl-col xl-col-6 bb-xl-max-w55 center bb-xl-left-align">
        <!-- ecperience -->
        <div class="relative bb-mt3pt56">
          <div 
          class="absolute bb-vcr bb-bc2 bb-w0pt5 bb-h0pt5 bb-br0pt5 bb-leftn1
          xs-hide sm-hide md-hide lg-hide"></div>
          <div class="bb-ff2 bb-fs1pt2 bb-fc1">
            {{ $lang.messages.select_experience }}
          </div>
        </div>
        <div class="bb-min-h3pt5">
          <div v-for="(experience, i) in experiences"
            class="relative mt2 inline-block">
            <div class="inline-block relative bb-pointer"
            :class="{'mr2': i !== experiences.length - 1, 'ml2': i !== 0}"
            @click="expSelect(experience.value._id, experience.doc.name)">
              <router-link :to="{ name: 'Booking', params: { playlistId:
              experience.value._id, playlistName: experience.doc.name}}" class="text-decoration-none">
                <div class="bb-ff2 bb-fs1pt29 bb-fc3 bb-transition4
                bb-bc12-hover bb-fc1-hover bb-px0pt8 bb-h2 bb-lh2" :class="{'bb-bc7 bb-fc11':
                selectedExpId === experience.value._id}">
                  {{ experience.doc.name }}
                </div>
              </router-link>
            </div>
          </div>
        </div>
        <div class="bb-ff2 bb-fs1pt29 bb-fc1 bb-mt2pt6">
          {{ $lang.messages.in_session }}
        </div>
        <div class="bb-h13pt5 mt2">
          <carrousel :swiperData="playlistData" v-if="playlistData"></carrousel>
          <div v-if="!playlistData"
            class="relative bb-w15 bb-mid-w30 bb-h100p mx-auto bb-xl-mli">
            <img class="absolute bb-vhcr bb-w5 bb-h5"
              src="../assets/images/loader.svg"></img>
          </div>
        </div>
        <div class="mt2 bb-mxw30 mx-auto bb-xl-ml0" v-if="selectedExperience">
          <div v-for="(genre, i) in selectedExperience.doc.keywords.genre"
            class="inline-block bb-ff2 bb-fs1 mr2 bb-fc12">
            {{ genre }}
          </div>
        </div>
        <div class="mt2 pb2 bb-ff2 bb-fs1 bb-fc3 bb-mxw30 mx-auto bb-xl-ml0"
        v-if="selectedExperience">
          {{ selectedExperience.doc.synopsis }}
        </div>
      </div>
      <div class="sm-col sm-col-12 xl-col-6 center bb-xl-left-align mt2 bb-xl-mt1">
        <!-- dates -->
        <div class="relative">
          <div class="bb-ff2 bb-fs1pt2 bb-fc1 mt2">
            {{ $lang.messages.select_date }}
          </div>
          <div 
          class="absolute bb-vcr bb-bc2 bb-w0pt5 bb-h0pt5 bb-br0pt5 bb-leftn1 xs-hide sm-hide md-hide lg-hide"></div>
        </div>
        <div>
          <div v-if="datesArr.length === 0"
            class="inline-block mx2 relative bb-h4pt5 bb-w3pt5 mt3">
            <div class="relative bb-vhcr">
              <div class="bb-ff3 bb-fs1pt29 bb-fc13 center">
              Day
              </div>
              <div class="bb-ff2 center bb-fs1pt29 bb-fc13 mx-auto mt1 bb-w2pt5 bb-h2pt5 bb-lh2pt5">
              0
              </div>
            </div>
          </div>
          <div v-else>
            <div class="sm-hide md-hide lg-hide xl-hide flex bb-jcc bb-aic mt3">
              <div class="inline-block bb-lg-mln2pt5"
              @click="datesSlidePrev"
              :class="{ 'bb-op0': datesSliderStart, 'bb-pointer': !datesSliderStart}">
                <i class="material-icons bb-fs2pt17 bb-fc1 bb-usnone">&#xE5CB;</i>
              </div>
              <div class="inline-block center bb-w80p bb-max-w40">
                <swiper :options="datesSwiperOption" ref="dates">
                  <swiper-slide v-for="(day, index) in datesArr"
                  :key="index">
                    <div
                    class="inline-block mx2 relative bb-h4pt5 bb-w3pt5">
                      <div class="relative bb-vhcr bb-hover-trigger2 bb-pointer"
                        :class="[ dateFullyBooked(campData[day.toDate()].showTimes) ?
                        'bb-default' : 'bb-pointer' ]"
                        @click="dateSelect(day, index)">
                        <div class="bb-ff3 bb-fs1pt29 bb-fc1 bb-transition4 center"
                        :class="{ 'bb-fc11': selectedDateIndex === index,
                        'bb-fc10': dateFullyBooked(campData[day.toDate()].showTimes) }">
                        {{ days[day.day()] }}
                        </div>
                        <div class="bb-ff2 center bb-fs1pt29 bb-fc1 bb-transition4
                        bb-fc9-hover mx-auto mt1 bb-w2pt5 bb-h2pt5 bb-lh2pt5"
                        :class="[ selectedDateIndex === index ? 'bb-fc11 bb-bc7' : '',
                        dateFullyBooked(campData[day.toDate()].showTimes) ? 'bb-fc10' : 'bb-bc12-hover' ]">
                        {{ day.date() }}
                        </div>
                      </div>
                    </div>
                  </swiper-slide>
                </swiper>
              </div>
              <div class="inline-block ml1"
                :class="[ datesSliderEnd ? 'bb-op0pt3' : '',
            datesSliderSlides <= 1 ? 'bb-op0' : 'bb-pointer']"
                @click="datesSlideNext">
                <i class="material-icons bb-fs2pt17 bb-fc1 bb-usnone">&#xE5CC;</i>
              </div>
            </div>
            <div v-for="(day, index) in datesArr"
              class="inline-block mx2 relative bb-h4pt5 bb-w3pt5 mt3 xs-hide">
              <div class="relative bb-vhcr bb-hover-trigger2"
                :class="[ dateFullyBooked(campData[day.toDate()].showTimes) ? 'bb-default' : 'bb-pointer' ]"
                @click="dateSelect(day, index)">
                <div class="bb-ff3 bb-fs1pt29 bb-fc1 bb-transition4 center"
                  :class="{ 'bb-fc11': selectedDateIndex === index,
                  'bb-fc10': dateFullyBooked(campData[day.toDate()].showTimes) }">
                  {{ days[day.day()] }}
                </div>
                <div class="bb-ff2 center bb-fs1pt29 bb-fc1 bb-transition4
                  bb-fc9-hover mx-auto mt1 bb-w2pt5 bb-h2pt5 bb-lh2pt5"
                  :class="[ selectedDateIndex === index ? 'bb-fc11 bb-bc7' : '',
                  dateFullyBooked(campData[day.toDate()].showTimes) ? 'bb-fc10' : 'bb-bc12-hover' ]">
                  {{ day.date() }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- time -->
        <div class="relative">
          <div class="bb-mt2pt6 bb-ff2 bb-fs1pt2 bb-fc1">
            {{ $lang.messages.select_session }}
          </div>
          <div 
          class="absolute bb-vcr bb-bc2 bb-w0pt5 bb-h0pt5 bb-br0pt5 bb-leftn1 xs-hide sm-hide md-hide lg-hide"></div>
        </div>
        <div class="clearfix" v-if="timesPlaceholder.length < 6">
          <div class="bb-mt1pt3 mx-auto flex bb-jcc bb-aic bb-xl-jcl" v-if="timesPlaceholder.length === 0">
            <div class="inline-block mt1 bb-lg-mln2pt5 bb-op0">
              <i class="material-icons bb-fs2pt17 bb-fc1 bb-usnone">&#xE5CB;</i>
            </div>
            <div class="inline-block center bb-w80p bb-max-w40">
              <swiper>
                <swiper-slide>
                  <div class="inline-block relative px1">
                    <div class="bb-ff2 bb-fs1pt29 bb-transition4
                bb-px0pt8 bb-h2 bb-lh2 bb-fc13">
                      0am
                    </div>
                  </div>
                </swiper-slide>
              </swiper>
            </div>
            <div class="inline-block bb-pointer ml1 mt1 bb-op0">
              <i class="material-icons bb-fs2pt17 bb-fc1 bb-usnone">&#xE5CC;</i>
            </div>
          </div>
          <div v-for="(showTime, i) in timesPlaceholder"
            class="relative bb-mt1pt7 inline-block px1" v-else>
            <div class="inline-block relative"
            @click="timeSelect(showTime)">
              <div class="bb-ff2 bb-fs1pt29 bb-transition4
              bb-px0pt8 bb-h2pt5 bb-lh2pt5 bb-h2 bb-lh2"
              :class="[
              searchTimePlaceholder(showTime) ? 'bb-fc3 bb-bc12-hover bb-fc1-hover bb-pointer' : 'bb-fc10 bb-default', showTime
              === selectedTime ? 'bb-bc7 bb-fc11' : '']">
              {{ showTime | formatHours}}
              </div>
            </div>
          </div>
        </div>
        <div class="bb-mt1pt3 mx-auto flex bb-jcc bb-aic bb-xl-jcl" v-else>
          <div class="inline-block mt1 bb-lg-mln2pt5"
            @click="sessionSlidePrev"
            :class="{ 'bb-op0': sessionSliderStart, 'bb-pointer': !sessionSliderStart}">
            <i class="material-icons bb-fs2pt17 bb-fc1 bb-usnone">&#xE5CB;</i>
          </div>
          <div class="inline-block center bb-w80p bb-max-w40">
            <swiper :options="sessionSwiperOption" ref="sessions">
              <swiper-slide v-for="(showTime, i) in timesPlaceholder"
              :key="showTime">
                <div class="inline-block relative px1">
                  <div class="bb-ff2 bb-fs1pt29 bb-transition4
              bb-px0pt8 bb-h2pt5 bb-lh2pt5 bb-h2 bb-lh2"
                    :class="[searchTimePlaceholder(showTime) ? 'bb-fc3 bb-bc12-hover bb-fc1-hover bb-pointer' : 'bb-fc10 bb-default', 
                    showTime === selectedTime ? 'bb-bc7 bb-fc11' : '']"
                    @click="timeSelect(showTime)">
                    {{ showTime | formatHours}}
                  </div>
                </div>
              </swiper-slide>
            </swiper>
          </div>
          <div class="inline-block ml1 mt1"
            :class="[ sessionSliderEnd ? 'bb-op0pt3' : '',
            sessionSliderSlides <= 1 ? 'bb-op0' : 'bb-pointer']"
            @click="sessionSlideNext">
            <i class="material-icons bb-fs2pt17 bb-fc1 bb-usnone">&#xE5CC;</i>
          </div>
        </div>
        <!-- places -->
        <div class="relative">
          <div class="bb-mt2pt6 bb-ff2 bb-fs1pt2 bb-fc1">
            {{ $lang.messages.select_places }}
          </div>
          <div 
          class="absolute bb-vcr bb-bc2 bb-w0pt5 bb-h0pt5 bb-br0pt5 bb-leftn1 xs-hide sm-hide md-hide lg-hide"></div>
        </div>
        <div v-if="seatsPlaceholder === 0">
          <div class="inline-block relative px2 bb-mt1pt7">
            <div class="bb-fs1pt29 bb-ff2 bb-transition4 bb-w2pt5 bb-h2pt5
            bb-lh2pt5 center bb-fc13">
            00
            </div>
          </div>
        </div>
        <div v-else-if="seatsPlaceholder < 3">
          <div class="inline-block relative px2 bb-mt1pt7" v-for="n in seatsPlaceholder">
            <div class="bb-fs1pt29 bb-ff2 bb-transition4 bb-w2pt5 bb-h2pt5
            bb-lh2pt5 center"
            :class="[selectedOptions.selectedPlaces === n ? 'bb-fc11 bb-bc7' : '',
            searchPlacesPlaceholder(n) ? 'bb-fc3 bb-bc12-hover bb-fc1-hover bb-pointer'
            : 'bb-fc10 bb-default']" @click="selectPlaces(n)">
              {{ (n / 10 < 1 ? '0' : '') + n }}
            </div>
          </div>
        </div>
        <div class="bb-mt1pt3 mx-auto flex bb-jcc bb-aic bb-xl-jcl" v-else>
          <div class="inline-block mt1 bb-lg-mln2pt5"
            @click="placesSlidePrev"
            :class="{ 'bb-op0': placesSliderStart, 'bb-pointer': !placesSliderStart}">
            <i class="material-icons bb-fs2pt17 bb-fc1 bb-usnone">&#xE5CB;</i>
          </div>
          <div class="inline-block center bb-w80p bb-max-w40">
            <swiper :options="placesSwiperOption" ref="places">
              <swiper-slide v-for="n in seatsPlaceholder" :key="n">
                <div class="inline-block relative">
                  <div class="bb-fs1pt29 bb-ff2 bb-transition4 bb-w2pt5 bb-h2pt5
                  bb-lh2pt5"
                    :class="[selectedOptions.selectedPlaces === n ? 'bb-fc11 bb-bc7' : '',
                    searchPlacesPlaceholder(n) ? 'bb-fc3 bb-bc12-hover bb-fc1-hover bb-pointer'
                    : 'bb-fc10 bb-default']"
                    @click="selectPlaces(n)">
                    {{ (n / 10 < 1 ? '0' : '') + n }}
                  </div>
                </div>
              </swiper-slide>
            </swiper>
          </div>
          <div class="inline-block ml1 mt1"
            :class="[ placesSliderEnd ? 'bb-op0pt3' : '',
            placesSliderSlides <= 1 ? 'bb-op0' : 'bb-pointer']"
            @click="placesSlideNext">
            <i class="material-icons bb-fs2pt17 bb-fc1 bb-usnone">&#xE5CC;</i>
          </div>
        </div>
        <div class="bb-mt2pt6 bb-w100p bb-h0pt1 bb-bc8 mt2 bb-bc13 bb-mxw31pt3 mx-auto bb-xl-ml0"></div>
        <div class="clearfix">
          <div class="xl-col bb-ff2 bb-fs1pt2 bb-fc4 bb-mt2pt6 bb-xl-mt2">
            {{ $lang.messages.your_booking }}
          </div>
          <div v-if="selectedUTCDate !== null && selectedTime !== null && selectedOptions.selectedPlaces !== 0"
            class="xl-col xl-col-8 bb-ff2 bb-fs1pt29 bb-fc3 mt2 bb-xl-mt2
            bb-xl-pl2 border-box">
            {{fullDays[selectedUTCDate.getDay()]}}
            {{selectedUTCDate.getDate()}} @ {{selectedTime | formatHours}}
            #{{ (selectedOptions.selectedPlaces / 10 < 1 ? '0' : '') + selectedOptions.selectedPlaces }}
          </div>
          <div v-if="selectedUTCDate === null || selectedTime === null
            || selectedOptions.selectedPlaces === 0"
            class="xl-col xl-col-8 bb-ff2 bb-fs1pt29 bb-fc3 mt2 bb-xl-mt2 bb-xl-pl2 border-box">
            {{ allDatesFullyBooked() ? '' : $lang.messages.select_phrase }}
          </div>
        </div>
        <div class="clearfix">
          <div class="xl-col bb-ff2 bb-fs1pt2 bb-fc4 mt2">
            {{ $lang.messages.total_payment }}
          </div>
          <div v-if="selectedTime !== null && selectedOptions.selectedPlaces !== 0"
            class="xl-col xl-col-3 bb-ff2 bb-fs1pt29 bb-fc3 mt2 bb-xl-pl2">
            ${{ selectedOptions.selectedPlaces * this.selectedOptions.sessionData.price}}
          </div>
          <div v-if="selectedTime === null || selectedOptions.selectedPlaces === 0"
            class="xl-col xl-col-3 bb-ff2 bb-fs1pt29 bb-fc3 mt2 bb-xl-pl2">
            $0
          </div>
        </div>
        <div class="bb-mt2pt6 bb-w100p bb-h0pt1 bb-bc8 mt2 bb-bc13 bb-mxw31pt3
        mx-auto bb-xl-ml0"></div>
        <div class="clearfix">
          <div class="mt2 bb-mxw31pt3 mx-auto bb-xl-ml0 bb-w100p">
            <div class="center mx-auto border-box bb-pointer bb-bc2-hover bb-bc2 bb-sm-bc-transp
              bb-ff3 bb-fs1 bb-fc1 bb-sm-fc2 bb-fc1-hover bb-brd3 bb-h2pt5 bb-py1pt25 bb-lh0
              bb-transition2"
              @click="checkOut">
              {{ $lang.messages.check_out }}
            </div>
          </div>
        </div>
        <div class="bb-ff2 bb-fs1pt29 bb-fc3 mt2">
          <div class="inline-block">{{verificationPh}}</div>          
          <div class="inline-block bb-fc2">{{username}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import carrousel from '@/components/swiper'
var dayjs = require('dayjs')
export default {
  name: 'Booking',
  components: {
    'carrousel': carrousel
  },
  data () {
    let self = this
    return {
      places: 12,
      days: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
      fullDays: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
      timesPlaceholder: [],
      seatsPlaceholder: 0,
      selectedOptions: {
        timestamp: '',
        selectedPlaces: 0,
        sessionData: null,
        experienceId: null,
        experienceName: null
      },
      selectedExpId: '',
      selectedUTCDate: null,
      selectedTime: null,
      selectedDateIndex: null,
      placesSliderStart: true,
      placesSliderEnd: false,
      placesSliderSlides: 2,
      placesSwiperOption: {
        slidesPerView: 8,
        spaceBetween: 0,
        simulateTouch: false,
        onReachBeginning: function (swiper) {
          self.placesSliderStart = true
        },
        onReachEnd: function (swiper) {
          if (swiper.snapGrid.length > 1) {
            self.placesSliderEnd = true
          } else {
            self.placesSliderSlides = swiper.snapGrid.length
          }
        },
        breakpoints: {
          1167: {
            slidesPerView: 5,
            spaceBetween: 0
          },
          736: {
            slidesPerView: 3,
            spaceBetween: 0
          }
        }
      },
      sessionSliderStart: true,
      sessionSliderEnd: false,
      sessionSliderSlides: 2,
      sessionSwiperOption: {
        slidesPerView: 6,
        spaceBetween: 0,
        simulateTouch: false,
        onReachBeginning: function (swiper) {
          self.sessionSliderStart = true
        },
        onReachEnd: function (swiper) {
          self.sessionSliderEnd = true
          if (swiper.snapGrid.length > 1) {
            self.sessionSliderEnd = true
          } else {
            self.sessionSliderSlider = swiper.snapGrid.length
          }
        },
        breakpoints: {
          736: {
            slidesPerView: 3,
            spaceBetween: 0
          }
        }
      },
      datesSliderStart: true,
      datesSliderEnd: false,
      datesSliderSlides: 2,
      datesSwiperOption: {
        slidesPerView: 3,
        spaceBetween: 0,
        simulateTouch: false,
        onReachBeginning: function (swiper) {
          self.datesSliderStart = true
        },
        onReachEnd: function (swiper) {
          if (swiper.snapGrid.length > 1) {
            self.datesSliderEnd = true
          } else {
            self.datesSliderSlides = swiper.snapGrid.length
          }
        }
      },
      verificationPh: self.$lang.messages.verification_ph,
      username: '',
      datesArr: [],
      sessionArr: [],
      campData: {},
      campBeginDay: dayjs(),
      campEndDay: dayjs().add(6, 'day')
    }
  },
  computed: {
    placesSwiper() {
      return this.$refs.places.swiper
    },
    sessionSwiper() {
      return this.$refs.sessions.swiper
    },
    datesSwiper() {
      return this.$refs.dates.swiper
    },
    playlistData () {
      return this.$store.getters.getItems
    },
    experiences () {
      return this.$store.getters.getHomeData
    },
    selectedExperience () {
      if (this.experiences) {
        return this.experiences.find(item => item.doc._id === this.selectedExpId)
      }
    },
    seatsCampaign () {
      return this.$store.getters.getSeatCampaign
    },
    userLoggedOut () {
      return this.$store.getters.getLoggedIn
    }
  },
  watch: {
    userLoggedOut: function () {
      if (!this.$store.getters.getLoggedIn) {
        this.verificationPh = this.$lang.messages.verification_ph
        this.username = ''
      } else {
        if (this.$store.getters.getVoucherToken) {
          this.verificationPh = this.$lang.messages.checkout_ph
          this.username = this.$store.getters.getVoucherToken.username
        }
      }
    },
    seatsCampaign: function () {
      var initial = dayjs(this.seatsCampaign[0].value.time)
      this.datesArr[0] = initial
      var tempShow = {}
      for (var i in this.seatsCampaign) {
        if (initial.day() !== dayjs(this.seatsCampaign[i].value.time).day()) {
          this.datesArr.push(dayjs(this.seatsCampaign[i].value.time))
          initial = dayjs(this.seatsCampaign[i].value.time)
          tempShow = {}
        }
        this.createCampaignData(tempShow, this.seatsCampaign[i])
        //reserve placeholders with max number of session times
        if (this.timesPlaceholder.indexOf(dayjs(this.seatsCampaign[i].value.time).hour())
          === -1) {
          this.timesPlaceholder.push(dayjs(this.seatsCampaign[i].value.time).hour())
        }
        //reserve placeholders with max number of seats
        if (this.seatsPlaceholder < this.seatsCampaign[i].value.seats.max) {
          this.seatsPlaceholder = this.seatsCampaign[i].value.seats.max
        }
        //main object that holds #of seats price campaignId and session time
        this.campData[initial.toDate()] = {showTimes: tempShow}
      }

      // add missing days from schedule (unavailable days)
      var day = this.campBeginDay
      // looping from campaign start day to end day
      while (!day.isAfter(this.campEndDay)) {
        var sameDay = false
        //check if day already exists in schedule
        for (var i in this.datesArr) {
          if (day.date() === this.datesArr[i].date() &&
            day.month() === this.datesArr[i].month()) {
            sameDay = true
            break
          }
        }

        // if day doesnt exist in schedule then add it
        if (!sameDay) {
          // find the index where day should be added
          for (var i in this.datesArr) {
            var temp = this.datesArr[i]
            if (day.date() > this.datesArr[0].date()) {
              if (temp.add(1, 'day').date() === day.date()) {
                this.datesArr.splice(parseInt(i) + 1, 0, day)
              }
            }

            if (day.date() < this.datesArr[0].date()) {
              this.datesArr.splice(0, 0, day)
            }
          }

          // add empty seats
          var temp = {}
          for (var key in tempShow) {
            temp[key] = {}
            for (var keyTwo in tempShow[key]) {
              temp[key][keyTwo] = 0
            }
          }
          this.campData[day.toDate()] = {showTimes: temp}
        }

        day = day.add(1, 'day')
      }

      // sorting the times placeholders 
      this.timesPlaceholder.sort((a, b) => a - b)
    },
    selectedTime: function () {
      this.selectedOptions.selectedPlaces = 0
    },
    'selectedOptions.selectedPlaces': function () {
      this.selectedOptions.timestamp = this.fullDays[this.selectedUTCDate.getDay()] + ' ' +
      this.selectedUTCDate.getDate() + ' @ ' + this.$options.filters.formatHours(this.selectedTime)
      + ' #' + (this.selectedOptions.selectedPlaces / 10 < 1 ? '0' : '') + this.selectedOptions.selectedPlaces
    },
  },
  methods: {
    placesSlidePrev: function () {
      this.placesSwiper.slidePrev(true, 500)
      this.placesSliderEnd = false
    },
    placesSlideNext: function () {
      this.placesSwiper.slideNext(true, 500)
      this.placesSliderStart = false
    },
    sessionSlidePrev: function () {
      this.sessionSwiper.slidePrev(true, 500)
      this.sessionSliderEnd = false
    },
    sessionSlideNext: function () {
      this.sessionSwiper.slideNext(true, 500)
      this.sessionSliderStart = false
    },
    datesSlidePrev: function () {
      this.datesSwiper.slidePrev(true, 500)
      this.datesSliderEnd = false
    },
    datesSlideNext: function () {
      this.datesSwiper.slideNext(true, 500)
      this.datesSliderStart = false
    },
    selectPlaces: function (places) {
      if (!this.allDatesFullyBooked()) {
        if (this.selectedUTCDate) {
          if (places <=
            this.campData[this.selectedUTCDate].showTimes[this.selectedTime].seats)
            {
              this.selectedOptions.selectedPlaces = places
          } else {
            this.$store.commit('SET_DISPLAY_NOTIFICATION', {show: true,
            msg:this.$lang.messages.err6, state: false})
          }
        } else {
          this.$store.commit('SET_DISPLAY_NOTIFICATION', {show: true,
          msg:this.$lang.messages.err6, state: false})
        }
      } else {
        this.showAllDatesFullyBookedMsg()
      }
    },
    getImageUrl: function (uri, name) {
      return this.$store.getters.getImageUrl(uri, name)
    },
    dateSelect: function (day, index) {
      if (!this.dateFullyBooked(this.campData[day.toDate()].showTimes)) {
        this.selectedUTCDate = day.toDate()
        this.selectedDateIndex = index
        for (var i in this.campData[this.selectedUTCDate].showTimes) {
          if (this.campData[this.selectedUTCDate].showTimes[i].seats > 0) {
            this.selectedTime = parseInt(i)
            this.selectedOptions.sessionData =
            this.campData[this.selectedUTCDate].showTimes[i]
            break
          }

          // if there are no seats, remove selections
          this.selectedTime = null
        }
      } else if (!this.allDatesFullyBooked()) {
        this.$store.commit('SET_DISPLAY_NOTIFICATION', {
          show: true,
          msg: this.$lang.messages.err6,
          state: false}
        )
      } else {
        this.showAllDatesFullyBookedMsg()
      }
    },
    timeSelect: function (time) {
      if (!this.allDatesFullyBooked()) {
        if (this.searchTimePlaceholder(time)) {
          this.selectedTime = time
          this.selectedOptions.sessionData = this.campData[this.selectedUTCDate].showTimes[time]
        } else {
          this.$store.commit('SET_DISPLAY_NOTIFICATION', {show: true,
          msg:this.$lang.messages.err6, state: false})
        }
      } else {
        this.showAllDatesFullyBookedMsg()
      }
    },
    expSelect: function (id, name) {
      this.$store.commit('SET_ITEMS', null)
      this.selectedExpId = id
      this.selectedOptions.experienceName = name
      this.$store.dispatch('LOAD_ITEMS', id)
    },
    checkOut: function () {
      if (this.allDatesFullyBooked()) {
        this.showAllDatesFullyBookedMsg()
      } else {
        if (this.selectedOptions.selectedPlaces === 0  || !this.selectedUTCDate ||
          this.selectedTime === null) {
            this.$store.commit('SET_DISPLAY_NOTIFICATION', {show: true, msg:this.$lang.messages.err1, state: false})
        } else {
          this.$store.commit('SET_SELECTED_OPTIONS', this.selectedOptions)
          this.$router.push({ name: 'Checkout'})
        }
      }
    },
    searchTimePlaceholder: function (value) {
      if (this.selectedUTCDate) {
        if (
        Object.keys(this.campData[this.selectedUTCDate].showTimes).indexOf(value.toString())
        >= 0) {
          if (this.campData[this.selectedUTCDate].showTimes[value].seats > 0) {
            return true
          }
        }
      }
    },
    searchPlacesPlaceholder: function (value) {
      if (this.selectedUTCDate && this.selectedTime !== null) {
        if (value <= this.campData[this.selectedUTCDate].showTimes[this.selectedTime].seats) {
          return true
        }
      }
    },
    createCampaignData: function (campObj, data) {
      campObj[dayjs(data.value.time).hour()] = {seats: data.value.seats.sum, price:
      data.value.price.sum, campaignId: data.key[data.key.length - 1][data.key[data.key.length
      - 1].length - 1], time: data.value.time}
    },
    handleResize: function () {
      if (this.seatsPlaceholder >= 3) {
        if (this.placesSwiper.snapGrid.length > 1) {
          this.placesSliderEnd = false
          this.placesSliderSlides = this.placesSwiper.snapGrid.length
          this.placesSwiper.slideTo(0, 500, false)
        }
      }
    },
    // checks if a particular date is fully booked
    dateFullyBooked: function (date) {
      var fullyBooked = true
      for (var key in date) {
        if (date[key].seats !== 0) {
          fullyBooked = false
          break
        }
      }
      return fullyBooked
    },
    // checks if all dates are fully booked
    allDatesFullyBooked: function () {
      var fullyBooked = true
      for (var i in this.campData) {
        if (!this.dateFullyBooked(this.campData[i].showTimes)) {
          fullyBooked = false
          break
        }
      }
      return fullyBooked
    },
    showAllDatesFullyBookedMsg: function() {
      var errorMsg = this.$lang.messages.err7
      if (this.selectedOptions.experienceName === 'Theatre') {
        errorMsg = this.$lang.messages.err8
      }
      this.$store.commit('SET_DISPLAY_NOTIFICATION', {
        show: true,
        msg: errorMsg,
        state: false
      })
    }
  },
  filters: {
    formatHours: function (date) {
      var ampm = date >= 12 ? 'pm' : 'am'
      date = date % 12
      date = date ? date : 12
      var strTime = date + ampm
      return strTime
    }
  },
  mounted () {
    this.selectedExpId = this.$route.params.playlistId
    this.$store.dispatch('LOAD_ITEMS', this.selectedExpId)
    this.$store.dispatch('LOAD_SCHEDULE', 'home')
    this.selectedOptions.experienceId = this.selectedExpId
    this.selectedOptions.experienceName = this.$route.params.playlistName
    
    if (this.userLoggedIn) {
      this.verificationPh = this.$lang.messages.checkout_ph
      this.username = this.$localStorage.get('username')
    }

    // start end date calculated with dayjs
    var seatCampaignParams = {
      id: this.selectedExpId,
      name: 'booking',
      beginDate: this.campBeginDay.startOf('day').toISOString(),
      endDate: this.campEndDay.endOf('day').toISOString()
    }
    this.$store.dispatch('LOAD_SEAT_CAMPAIGN', seatCampaignParams)
    window.addEventListener('resize', this.handleResize)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/booking.vue